import { createSlice } from '@reduxjs/toolkit'
//import { setToken } from 'utils/auth'

export const loginSlice = createSlice({
	name: 'login',
	initialState: {
		isLoading: false,
		terms: null,
		policy: null,
		isEmailPopup: false,
	},
	reducers: {
		getEmailStart: (state) => {
			state.isLoading = true
		},
		getEmailError: (state) => {
			state.isLoading = false
		},
		getLoginStart: (state) => {
			state.isLoading = true
		},
		getLoginSuccess: (state, { payload }) => {
			state.isLoading = false
			//setToken(JSON.stringify(payload));
		},
		getLoginError: (state) => {
			state.isLoading = false
		},
		/**
		 * getTerms {Function}
		 * @description - set an appropriate terms data to the state.
		 * */
		getTerms: (state, { payload }) => {
			state.terms = payload
		},
		/**
		 * getPolicy {Function}
		 * @description - set an appropriate plicy data to the state.
		 * */
		getPolicy: (state, { payload }) => {
			state.policy = payload
		},
	},
})

export const {
	getEmailStart,
	getEmailError,
	getLoginStart,
	getLoginSuccess,
	getLoginError,
	getTerms,
	getPolicy,
} = loginSlice.actions
export const { reducer } = loginSlice
